import
{
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Filter, FilterElement } from "@idto";
import { AnalyticsService } from "@service/analytics/abstract/analytics.service";
import * as noUiSlider from "nouislider";
@Component({
    selector: "app-interval-filter",
    templateUrl: "./interval-filter.component.html",
    styleUrls: ["./interval-filter.component.scss"],
    standalone: false
})
export class IntervalFilterComponent implements AfterViewInit
{
  get filter(): Filter
  {
    return this._filter;
  }

  @Input() set filter(value: Filter)
  {
    this._filter = value;
    if (value && this.slider)
    {
      this.updateValues(
        value.selectedInterval.min,
        value.selectedInterval.max,
        false
      );
    }
  }

  @ViewChild("slider", { static: true }) private sliderWrapper: ElementRef;
  @ViewChild("min", { static: true }) private min: ElementRef;
  @ViewChild("max", { static: true }) private max: ElementRef;
  private _filter: Filter;
  private slider: noUiSlider.API;

  @Output()
  private readonly valueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private analyticsService: AnalyticsService)
  {

  }


  public ngAfterViewInit(): void
  {
    noUiSlider.create(this.sliderWrapper.nativeElement, {
      start: [
        this._filter.selectedInterval.min,
        this._filter.selectedInterval.max,
      ],
      range: this.prepareRange(),
      margin: 0,
      connect: true,
      step: this._filter.intervalStep,
      format: {
        to: (value: any) =>
        {
          let toFixed = 0;
          if (this._filter.intervalStep < 1)
          {
            toFixed = 2;
          }
          return parseFloat(value).toFixed(toFixed);
        },
        from: (value: any) =>
        {
          let toFixed = 0;
          if (this._filter.intervalStep < 1)
          {
            toFixed = 2;
          }
          return parseFloat(value);
        },
      },
    });
    this.slider = this.sliderWrapper.nativeElement.noUiSlider;
    this.slider.on("slide", (values: any) =>
    {
      this.updateValues(values[0], values[1], false);
    });

    this.slider.on("change", (values: any) =>
    {
      this.valueChanged.emit(this.filter);
      this.analyticsService.registerEvent('select_filter_attribute_value', {
        filter_attribute_name: this.filter.code,
        filter_attribute_value_from: this.filter.selectedInterval.min,
        filter_attribute_value_to: this.filter.selectedInterval.max
      }, false)
    });
  }

  public onSelectedMinimumChange(value: string): void
  {
    this.setMinimum(value);
  }

  public trackByIndex(index, item): number
  {
    return item?.code ?? index;
  }

  public onSelectedMaximumChange(value: string): void
  {
    this.setMaximum(value);
  }

  private setMinimum(value: string): void
  {
    if (!value)
    {
      return;
    }
    this.slider.set([value, this.filter.selectedInterval.max]);
    this.updateValues(value, this.filter.selectedInterval.max, true);
  }

  private setMaximum(value: string): void
  {
    if (!value)
    {
      return;
    }
    this.updateValues(this.filter.selectedInterval.min, value, true);
    this.slider.set([this.filter.selectedInterval.min, value]);
  }

  private prepareRange(): any
  {
    const range = {
      min: [this._filter.local.min],
      max: [this._filter.local.max],
    };
    if (this.filter.intervalQuantiles)
    {
      const parts = this.filter.intervalQuantiles.length;
      const step = 100 / (parts + 1);

      for (let i = 0; i < parts; i++)
      {
        range[((i + 1) * step).toFixed(2)] = [this.filter.intervalQuantiles[i]];
      }
    }

    return range;
  }

  private updateValues(
    minimum: any,
    maximum: any,
    updateSlider: boolean = true
  ): void
  {
    this.slider.updateOptions({
      range: this.prepareRange()
    }, false);

    if (!isNaN(minimum))
    {
      minimum = parseFloat(minimum);
      if (minimum < this.filter.local.min)
      {
        minimum = this._filter.local.min;
      } else if (minimum >= this.filter.selectedInterval.max)
      {
        minimum = this.filter.selectedInterval.max;
      }
      this.filter.selectedInterval.min = minimum;
      this.min.nativeElement.value = minimum;

      this.slider.updateOptions({
        start: [minimum, this._filter.selectedInterval.max],
      }, false);
    }
    if (!isNaN(maximum))
    {
      maximum = parseFloat(maximum);
      if (maximum > this.filter.local.max)
      {
        maximum = this._filter.local.max;
      } else if (maximum <= this.filter.selectedInterval.min)
      {
        maximum = this.filter.selectedInterval.min;
      }
      this.filter.selectedInterval.max = maximum;
      this.max.nativeElement.value = maximum;

      this.slider.updateOptions({
        start: [this._filter.selectedInterval.min, maximum],
      }, false);
    }
    if (updateSlider)
    {
      this.slider.set([
        this.filter.selectedInterval.min,
        this.filter.selectedInterval.max,
      ]);
      this.valueChanged.emit(this.filter);
    }
  }

  public toggleSelected(filterOption: FilterElement, filter: Filter): void
  {
    if (filterOption.recordCount > 0)
    {
      filterOption.selected = !filterOption.selected;
      this.valueChanged.emit(filter);
    }
  }

  @HostListener("keydown", ["$event"])
  private trackEvent($event: any): void
  {
    if ($event.keyCode === 13)
    {
      $event.target.blur();
      $event.target.focus();
      $event.stopPropagation();
      $event.preventDefault();
    }
  }
}
